import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { urls } from '../../utils/url-utils';
import { errorHandl } from '../../utils/network-utils';

@Injectable({
  providedIn: 'root'
})
export class ClientLockService {

  constructor(private http: HttpClient) { }

  getClientLockIds(queryParams?): Observable<any> {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.CLIENTS_LOCK, { params })
      .pipe(catchError(errorHandl));
  }

  addClientLockId(payload): Observable<any> {
    return this.http.post<any>(urls.BASE_URL + urls.CLIENTS_LOCK, payload)
      .pipe(catchError(errorHandl));
  }

  updateClientLockId(id: string, payload): Observable<any> {
    return this.http.put<any>(urls.BASE_URL + urls.CLIENTS_LOCK + '/' + id, payload)
      .pipe(catchError(errorHandl));
  }

  deleteClientLockId(id: string): Observable<any> {
    return this.http.delete<any>(urls.BASE_URL + urls.CLIENTS_LOCK + '/' + id)
      .pipe(catchError(errorHandl));
  }
}
